import { AppReducerEvent, appRoutes } from 'globals/constants'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

export const useLogout = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const logout = () => {
    dispatch({ type: AppReducerEvent.LOG_OUT })
    navigate(appRoutes.login.path)
  }
  return { logout }
}
